(function() {
    const focusableSelector = 'a, button, input, select, textarea, [tabindex]';

    function isVisibleInViewport(slide, viewportRect) {
        const slideRect = slide.getBoundingClientRect();
        if (!slideRect.width || !slideRect.height) return false;

        const horizontalIntersection = Math.min(slideRect.right, viewportRect.right) - Math.max(slideRect.left, viewportRect.left);
        const verticalIntersection = Math.min(slideRect.bottom, viewportRect.bottom) - Math.max(slideRect.top, viewportRect.top);

        return horizontalIntersection > 1 && verticalIntersection > 1;
    }

    function isVisibleSlide(slide, hasVisibleClass, viewportRect) {
        if (hasVisibleClass) {
            return slide.classList.contains('swiper-slide-visible');
        }

        if (isVisibleInViewport(slide, viewportRect)) {
            return true;
        }

        return slide.classList.contains('swiper-slide-active');
    }

    function updateCarouselAccessibility(carousel) {
        const slides = carousel.querySelectorAll('.swiper-slide');
        if (!slides.length) return;

        const hasVisibleClass = carousel.querySelector('.swiper-slide.swiper-slide-visible') !== null;
        const viewportRect = carousel.getBoundingClientRect();
        const baseSlides = carousel.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)');
        const totalSlides = baseSlides.length || slides.length;

        slides.forEach(function(slide) {
            const isVisible = isVisibleSlide(slide, hasVisibleClass, viewportRect);
            const logicalIndex = slide.hasAttribute('data-swiper-slide-index')
                ? parseInt(slide.getAttribute('data-swiper-slide-index'), 10) + 1
                : Array.prototype.indexOf.call(slides, slide) + 1;

            slide.setAttribute('role', 'group');
            slide.setAttribute('aria-label', 'Slide ' + logicalIndex + ' of ' + totalSlides);
            slide.setAttribute('aria-hidden', isVisible ? 'false' : 'true');

            slide.querySelectorAll(focusableSelector).forEach(function(focusableElement) {
                if (!isVisible) {
                    if (!focusableElement.hasAttribute('data-original-tabindex')) {
                        if (focusableElement.hasAttribute('tabindex')) {
                            focusableElement.setAttribute('data-original-tabindex', focusableElement.getAttribute('tabindex'));
                        } else {
                            focusableElement.setAttribute('data-original-tabindex', '');
                        }
                    }

                    focusableElement.setAttribute('tabindex', '-1');
                    return;
                }

                if (focusableElement.hasAttribute('data-original-tabindex')) {
                    const originalTabindex = focusableElement.getAttribute('data-original-tabindex');

                    if (originalTabindex === '') {
                        focusableElement.removeAttribute('tabindex');
                    } else {
                        focusableElement.setAttribute('tabindex', originalTabindex);
                    }

                    focusableElement.removeAttribute('data-original-tabindex');
                }
            });
        });
    }

    function updatePaginationAccessibility(carousel) {
        const carouselWrapper = carousel.closest('.carousel-wrapper');
        if (!carouselWrapper) return;

        const pagination = carouselWrapper.querySelector('.swiper-pagination');
        if (!pagination) return;

        const bullets = pagination.querySelectorAll('.swiper-pagination-bullet');
        bullets.forEach(function(bullet, index) {
            bullet.setAttribute('aria-label', 'Go to slide ' + (index + 1));

            if (bullet.classList.contains('swiper-pagination-bullet-active')) {
                bullet.setAttribute('aria-current', 'true');
            } else {
                bullet.removeAttribute('aria-current');
            }
        });
    }

    function initFeaturedCollectionCarouselA11y(root) {
        const scope = root || document;
        const carousels = scope.querySelectorAll('.carousel--featured-collection, .carousel--category-driver, .carousel--featured-product');

        carousels.forEach(function(carousel) {
            if (carousel.dataset.a11yInit === 'true') return;
            carousel.dataset.a11yInit = 'true';

            updateCarouselAccessibility(carousel);
            updatePaginationAccessibility(carousel);

            const classObserver = new MutationObserver(function(mutations) {
                const hasClassMutation = mutations.some(function(mutation) {
                    return mutation.type === 'attributes' && mutation.attributeName === 'class';
                });

                if (hasClassMutation) {
                    updateCarouselAccessibility(carousel);
                    updatePaginationAccessibility(carousel);
                }
            });

            const observeSlides = function() {
                classObserver.disconnect();
                carousel.querySelectorAll('.swiper-slide').forEach(function(slide) {
                    classObserver.observe(slide, { attributes: true, attributeFilter: ['class'] });
                });
            };

            observeSlides();

            const wrapper = carousel.querySelector('.swiper-wrapper') || carousel;
            const listObserver = new MutationObserver(function() {
                observeSlides();
                updateCarouselAccessibility(carousel);
                updatePaginationAccessibility(carousel);
            });

            listObserver.observe(wrapper, { childList: true });

            const carouselWrapper = carousel.closest('.carousel-wrapper');
            const pagination = carouselWrapper ? carouselWrapper.querySelector('.swiper-pagination') : null;
            if (pagination) {
                const paginationObserver = new MutationObserver(function() {
                    updatePaginationAccessibility(carousel);
                });

                paginationObserver.observe(pagination, {
                    childList: true,
                    subtree: true,
                    attributes: true,
                    attributeFilter: ['class']
                });
            }

            window.addEventListener('resize', function() {
                updateCarouselAccessibility(carousel);
                updatePaginationAccessibility(carousel);
            });
        });
    }

    function updateProductThumbnailAriaCurrent(thumbnailsCarousel) {
        const thumbnails = thumbnailsCarousel.querySelectorAll('.product__thumbnail-item');
        thumbnails.forEach(function(thumb) {
            if (thumb.classList.contains('swiper-slide-thumb-active')) {
                thumb.setAttribute('aria-current', 'true');
            } else {
                thumb.removeAttribute('aria-current');
            }
        });
    }

    function initProductThumbnailA11y(root) {
        const scope = root || document;
        const thumbnailsCarousels = scope.querySelectorAll('.carousel--product-thumbnails');

        thumbnailsCarousels.forEach(function(carousel) {
            if (carousel.dataset.productThumbA11yInit === 'true') return;
            carousel.dataset.productThumbA11yInit = 'true';

            updateProductThumbnailAriaCurrent(carousel);

            const classObserver = new MutationObserver(function() {
                updateProductThumbnailAriaCurrent(carousel);
            });

            carousel.querySelectorAll('.product__thumbnail-item').forEach(function(thumb) {
                classObserver.observe(thumb, { attributes: true, attributeFilter: ['class'] });
            });
        });
    }

    function applyRebuySearchRegionAttributes(root) {
        const scope = root || document;
        const rebuySearchContainers = scope.querySelectorAll('.rebuy-quick-view-dropdown__container');
        if (!rebuySearchContainers.length) return;

        rebuySearchContainers.forEach(function(container, index) {
            container.setAttribute('role', 'region');
            container.setAttribute('aria-label', 'product filter');

            container.querySelectorAll('.rebuy-quick-view__overlay[role="dialog"]').forEach(function(dialogOverlay) {
                dialogOverlay.removeAttribute('aria-labelledby');
                dialogOverlay.setAttribute('aria-label', 'Product search dialog');
                dialogOverlay.setAttribute('aria-modal', 'true');
            });

            container.querySelectorAll('.rebuy-quick-view__product').forEach(function(productCard) {
                productCard.setAttribute('role', 'group');
                productCard.setAttribute('aria-label', 'product');
            });

            container.querySelectorAll('.rebuy-quick-view__product .rebuy-product-title').forEach(function(productTitle) {
                if (productTitle.querySelector(':scope > h3.rebuy-product-title-heading')) {
                    return;
                }

                const heading = document.createElement('h3');
                heading.className = 'rebuy-product-title-heading';

                while (productTitle.firstChild) {
                    heading.appendChild(productTitle.firstChild);
                }

                productTitle.appendChild(heading);
            });

            const searchInput = container.querySelector('.rebuy-quick-view-dropdown__search-input input[type="text"]');
            if (!searchInput) return;

            const instructionsId = 'rebuy-live-filter-instructions-' + index;
            let instructions = container.querySelector('#' + instructionsId);

            if (!instructions) {
                instructions = document.createElement('span');
                instructions.id = instructionsId;
                instructions.className = 'sr-only rebuy-live-filter-instructions';
                instructions.textContent = 'The following text field filters product and collection results as you type. Enter keywords to narrow the results.';
                searchInput.parentNode.insertBefore(instructions, searchInput);
            }

            const describedBy = searchInput.getAttribute('aria-describedby');
            if (!describedBy) {
                searchInput.setAttribute('aria-describedby', instructionsId);
            } else if (describedBy.split(' ').indexOf(instructionsId) === -1) {
                searchInput.setAttribute('aria-describedby', describedBy + ' ' + instructionsId);
            }

            const statusId = 'rebuy-live-filter-status-' + index;
            let liveStatus = container.querySelector('#' + statusId);

            if (!liveStatus) {
                liveStatus = document.createElement('span');
                liveStatus.id = statusId;
                liveStatus.className = 'sr-only rebuy-live-filter-status';
                liveStatus.setAttribute('aria-live', 'assertive');
                liveStatus.setAttribute('aria-atomic', 'true');
                searchInput.parentNode.insertBefore(liveStatus, searchInput);
            }

            if (searchInput.dataset.rebuyLiveBound !== 'true') {
                searchInput.dataset.rebuyLiveBound = 'true';
                searchInput.addEventListener('input', function() {
                    scheduleRebuyLiveAnnouncement(container);
                });
            }

            if (!container.__rebuyLiveObserver) {
                container.__rebuyLiveObserver = new MutationObserver(function() {
                    normalizeRebuyTitles(container);
                    scheduleRebuyLiveAnnouncement(container);
                });

                container.__rebuyLiveObserver.observe(container, {
                    childList: true,
                    subtree: true,
                    characterData: true,
                    attributes: true,
                    attributeFilter: ['class']
                });
            }

            bindRebuySeeMoreFocus(container);
            bindRebuyFocusTrap(container);
        });
    }

    function bindRebuyFocusTrap(container) {
        if (container.dataset.rebuyFocusTrapBound === 'true') return;
        container.dataset.rebuyFocusTrapBound = 'true';

        const focusableSelector = [
            'a[href]',
            'button:not([disabled])',
            'input:not([disabled])',
            'select:not([disabled])',
            'textarea:not([disabled])',
            '[tabindex]:not([tabindex="-1"])'
        ].join(', ');

        function isVisible(element) {
            const style = window.getComputedStyle(element);
            return style.visibility !== 'hidden' && style.display !== 'none' && element.getClientRects().length > 0;
        }

        function isContainerVisible() {
            return container.classList.contains('visible') || (container.parentElement && container.parentElement.classList.contains('visible'));
        }

        container.addEventListener('keydown', function(event) {
            if (event.key !== 'Tab') return;
            if (!isContainerVisible()) return;

            const focusableElements = Array.from(container.querySelectorAll(focusableSelector)).filter(isVisible);
            if (!focusableElements.length) return;

            const firstElement = focusableElements[0];
            const lastElement = focusableElements[focusableElements.length - 1];
            const activeElement = document.activeElement;

            if (event.shiftKey) {
                if (activeElement === firstElement || !container.contains(activeElement)) {
                    event.preventDefault();
                    lastElement.focus();
                }
                return;
            }

            if (activeElement === lastElement) {
                event.preventDefault();
                firstElement.focus();
            }
        });
    }

    function bindRebuySeeMoreFocus(container) {
        if (container.dataset.rebuySeeMoreBound === 'true') return;
        container.dataset.rebuySeeMoreBound = 'true';

        function handleSeeMoreActivation(seeMoreButton) {
            scheduleSeeMoreFocus(container, seeMoreButton);
        }

        container.addEventListener('click', function(event) {
            const seeMoreButton = event.target.closest('button.see-more');
            if (!seeMoreButton || !container.contains(seeMoreButton)) return;
            handleSeeMoreActivation(seeMoreButton);
        });

        container.addEventListener('keydown', function(event) {
            const seeMoreButton = event.target.closest('button.see-more');
            if (!seeMoreButton || !container.contains(seeMoreButton)) return;

            if (event.key === 'Enter' || event.key === ' ') {
                // Rebuy may handle keyboard activation without a delegated click bubbling as expected.
                // Trigger focus workflow here as well.
                window.setTimeout(function() {
                    handleSeeMoreActivation(seeMoreButton);
                }, 0);
            }
        });
    }

    function scheduleSeeMoreFocus(container, seeMoreButton) {
        function getSixthCollectionLink() {
            const currentCollectionList = container.querySelector('.rebuy-quick-view__collection-list');
            if (!currentCollectionList) return null;

            const links = currentCollectionList.querySelectorAll('.rebuy-quick-view__collection');
            return links.length > 5 ? links[5] : null;
        }

        function focusSixthCollectionLink() {
            const sixthLink = getSixthCollectionLink();
            if (sixthLink && typeof sixthLink.focus === 'function') {
                sixthLink.focus();
                return true;
            }

            return false;
        }

        if (focusSixthCollectionLink()) return;

        const seeMoreObserver = new MutationObserver(function() {
            if (focusSixthCollectionLink()) {
                seeMoreObserver.disconnect();
                window.clearTimeout(fallbackTimer);
            }
        });

        seeMoreObserver.observe(container, { childList: true, subtree: true });

        const fallbackTimer = window.setTimeout(function() {
            seeMoreObserver.disconnect();

            if (document.body.contains(seeMoreButton) && typeof seeMoreButton.focus === 'function') {
                seeMoreButton.focus();
                return;
            }

            const lastLink = container.querySelector('.rebuy-quick-view__collection-list .rebuy-quick-view__collection:last-of-type');
            if (lastLink && typeof lastLink.focus === 'function') {
                lastLink.focus();
            }
        }, 2500);
    }

    function normalizeRebuyTitles(root) {
        const scope = root || document;
        const titles = scope.querySelectorAll('p.rebuy-quick-view__title');

        titles.forEach(function(title) {
            const heading = document.createElement('h2');

            heading.className = title.className;
            heading.innerHTML = title.innerHTML;

            Array.from(title.attributes).forEach(function(attribute) {
                if (attribute.name === 'class') return;
                heading.setAttribute(attribute.name, attribute.value);
            });

            title.parentNode.replaceChild(heading, title);
        });
    }

    function getRebuyResultCount(container) {
        const productResults = container.querySelectorAll('.rebuy-quick-view__product').length;
        const collectionResults = container.querySelectorAll('.rebuy-quick-view__collection').length;
        return productResults + collectionResults;
    }

    function updateRebuyLiveAnnouncement(container) {
        const searchInput = container.querySelector('.rebuy-quick-view-dropdown__search-input input[type="text"]');
        const liveStatus = container.querySelector('.rebuy-live-filter-status');
        if (!searchInput || !liveStatus) return;

        const query = searchInput.value.trim();
        if (!query) {
            liveStatus.textContent = '';
            return;
        }

        const resultsCount = getRebuyResultCount(container);
        const message = resultsCount > 0 ? resultsCount + ' results available' : 'No results available';

        if (liveStatus.textContent !== message) {
            liveStatus.textContent = message;
        }
    }

    function scheduleRebuyLiveAnnouncement(container) {
        if (container.__rebuyLiveTimer) {
            window.clearTimeout(container.__rebuyLiveTimer);
        }

        container.__rebuyLiveTimer = window.setTimeout(function() {
            updateRebuyLiveAnnouncement(container);
        }, 120);
    }

    function initRebuySearchA11y() {
        normalizeRebuyTitles(document);
        applyRebuySearchRegionAttributes(document);

        const rebuyObserver = new MutationObserver(function(mutations) {
            const hasDomChanges = mutations.some(function(mutation) {
                return mutation.type === 'childList' && mutation.addedNodes.length > 0;
            });

            if (hasDomChanges) {
                normalizeRebuyTitles(document);
                applyRebuySearchRegionAttributes(document);
            }
        });

        rebuyObserver.observe(document.body, { childList: true, subtree: true });
    }

    function positionCookieBanner() {
        const cookieBanner = document.getElementById('onetrust-consent-sdk');
        if (!cookieBanner) return;

        const skipLink = document.querySelector('a.skip-link');
        const body = document.body;
        if (!body) return;

        if (skipLink && skipLink.parentNode === body) {
            if (skipLink.nextElementSibling !== cookieBanner) {
                body.insertBefore(cookieBanner, skipLink.nextSibling);
            }
            return;
        }

        if (body.firstElementChild !== cookieBanner) {
            body.insertBefore(cookieBanner, body.firstChild);
        }
    }

    function initCookieBannerPositioning() {
        positionCookieBanner();

        const cookieObserver = new MutationObserver(function() {
            positionCookieBanner();
        });

        cookieObserver.observe(document.body, { childList: true, subtree: false });
    }

    function wrapRebuyCartItemsWithGroup(container) {
        const scope = container || document;
        const itemsList = scope.querySelector('ul[data-smartcart-items]');
        if (!itemsList) return;

        itemsList.removeAttribute('role');

        const items = itemsList.querySelectorAll('li.rebuy-cart__flyout-item:not([data-rebuy-cart-item-a11y])');

        items.forEach(function(li) {
            li.setAttribute('data-rebuy-cart-item-a11y', 'true');
            li.removeAttribute('aria-label');

            const wrapper = document.createElement('div');
            wrapper.className = 'rebuy-cart__flyout-item-group';
            wrapper.setAttribute('role', 'group');
            wrapper.setAttribute('aria-label', 'product');

            while (li.firstChild) {
                wrapper.appendChild(li.firstChild);
            }
            li.appendChild(wrapper);
        });
    }

    function initRebuyCartItemA11y() {
        function run() {
            wrapRebuyCartItemsWithGroup(document);
        }

        run();

        const cartRoot = document.querySelector('div.rebuy-cart');
        
        if (cartRoot) {
            const observer = new MutationObserver(function(mutations) {
                const hasItemsChange = mutations.some(function(m) {
                    return m.type === 'childList' && (m.addedNodes.length || m.removedNodes.length);
                });
                if (hasItemsChange) {
                    run();
                }
            });
            observer.observe(cartRoot, { childList: true, subtree: true });
        }

        document.addEventListener('rebuy:smartcart.show', function() {
            run();
        });
        document.addEventListener('rebuy:smartcart.updated', function() {
            run();
        });
    }

    function initRebuyCartVisibilityA11y() {
        const TRANSITION_MS = 250;
        const cart = document.getElementById('rebuy-cart');
        if (!cart) {
            document.addEventListener('rebuy:smartcart.show', initRebuyCartVisibilityA11y, { once: true });
            return;
        }

        function updateVisibility() {
            if (cart.classList.contains('is-visible')) {
                cart.style.visibility = 'visible';
            } else {
                cart.style.visibility = 'hidden';
            }
        }

        updateVisibility();

        const observer = new MutationObserver(function(mutations) {
            const hasClassChange = mutations.some(function(m) {
                return m.type === 'attributes' && m.attributeName === 'class';
            });
            if (!hasClassChange) return;

            if (cart.classList.contains('is-visible')) {
                cart.style.visibility = 'visible';
            } else {
                setTimeout(function() {
                    cart.style.visibility = 'hidden';
                }, TRANSITION_MS);
            }
        });

        observer.observe(cart, { attributes: true, attributeFilter: ['class'] });
    }

    function focusRebuyCartAfterRemove() {
        const firstCartItem = document.querySelector('li.rebuy-cart__flyout-item');
        if (firstCartItem) {
            if (!firstCartItem.hasAttribute('tabindex')) {
                firstCartItem.setAttribute('tabindex', '-1');
            }

            firstCartItem.focus();
            return true;
        }

        const emptyCartLink = document.querySelector('.rebuy-cart__flyout-empty-cart a');
        if (emptyCartLink) {
            emptyCartLink.focus();
            return true;
        }

        return false;
    }

    function initRebuyCartRemoveFocus() {
        let pendingRemoveFocusObserver = null;

        function disconnectObservers() {
            if (pendingRemoveFocusObserver) {
                pendingRemoveFocusObserver.disconnect();
                pendingRemoveFocusObserver = null;
            }
        }

        document.addEventListener('click', function(event) {
            const removeButton = event.target.closest('button.rebuy-cart__flyout-item-remove');
            if (!removeButton) return;

            disconnectObservers();

            // Observe the cart container (not the UL), because the UL can be removed
            // entirely when cart becomes empty.
            const cartMutationRoot = removeButton.closest('div.rebuy-cart') || document.querySelector('div.rebuy-cart') || document.body;

            pendingRemoveFocusObserver = new MutationObserver(function(mutations) {
                const hasItemMutation = mutations.some(function(mutation) {
                    return mutation.type === 'childList';
                });

                if (!hasItemMutation) return;

                setTimeout(() => {
                    if (focusRebuyCartAfterRemove()) {
                        disconnectObservers();
                    }
                }, 500);
            });

            pendingRemoveFocusObserver.observe(cartMutationRoot, { childList: true, subtree: true });
        });
    }

    function replaceShopifyPolicySpanBWithH3(root) {
        const scope = root || document;
        const policyBody = scope.querySelector('.shopify-policy__body');
        if (!policyBody) return;

        policyBody.querySelectorAll('p').forEach(function(p) {
            if (p.children.length !== 1) return;
            const span = p.firstElementChild;
            if (!span || span.tagName !== 'SPAN') return;

            const b = span.querySelector('b');
            if (!b) return;

            const firstChild = span.firstElementChild;
            const firstChildOk = span.children.length === 1 || (firstChild && firstChild.tagName === 'BR');

            if (firstChildOk) {
                const h2 = document.createElement('h2');
                h2.className = 'shopify-policy__heading';
                h2.textContent = b.textContent;
                p.parentNode.replaceChild(h2, p);
            }
        });
    }

    function initHeaderMobileDialogA11y() {
        const MOBILE_BREAKPOINT = 1079;
        const container = document.querySelector('.header__container[data-mobile-dialog-attributes]');
        if (!container) return;
        const header = container.closest('header');
        if (!header) return;

        const mobileMenuLabel = container.getAttribute('data-mobile-menu-label') || 'Mobile menu dialog';

        function updateDialogAttributes() {
            const isMobile = window.innerWidth <= MOBILE_BREAKPOINT;
            if (isMobile) {
                container.setAttribute('role', 'dialog');
                container.setAttribute('aria-modal', 'true');
                container.setAttribute('aria-label', mobileMenuLabel);
            } else {
                container.removeAttribute('role');
                container.removeAttribute('aria-modal');
                container.removeAttribute('aria-label');
            }
        }

        function getFocusableElements() {
            return Array.from(container.querySelectorAll(focusableSelector)).filter(function(el) {
                if (el.getAttribute('tabindex') === '-1') return false;
                const style = window.getComputedStyle(el);
                if (style.visibility === 'hidden' || style.display === 'none') return false;
                return true;
            });
        }

        function handleKeydown(e) {
            if (e.key !== 'Tab') return;
            if (window.innerWidth > MOBILE_BREAKPOINT) return;
            if (!header.classList.contains('js--is-open')) return;

            const focusable = getFocusableElements();
            if (focusable.length === 0) return;

            const first = focusable[0];
            const last = focusable[focusable.length - 1];
            const activeEl = document.activeElement;

            if (e.shiftKey) {
                if (activeEl === first) {
                    e.preventDefault();
                    last.focus();
                }
            } else {
                if (activeEl === last) {
                    e.preventDefault();
                    first.focus();
                }
            }
        }

        function handleFocusIn(e) {
            if (window.innerWidth > MOBILE_BREAKPOINT) return;
            if (!header.classList.contains('js--is-open')) return;
            if (container.contains(e.target)) return;

            const focusable = getFocusableElements();
            if (focusable.length === 0) return;

            const first = focusable[0];
            const last = focusable[focusable.length - 1];
            const fromFirst = e.relatedTarget === first;

            setTimeout(function() {
                (fromFirst ? last : first).focus();
            }, 0);
        }

        document.addEventListener('keydown', handleKeydown, true);
        document.addEventListener('focusin', handleFocusIn, true);
        updateDialogAttributes();
        window.addEventListener('resize', updateDialogAttributes);
    }

    function replaceContactPageStrongWithH2(root) {
        const scope = root || document;
        const contentRoot = scope.querySelector('#contact-thymes-customer-service-thymes .main-page__content');
        if (!contentRoot) return;

        contentRoot.querySelectorAll('strong').forEach(function(strongElement) {
            const heading = document.createElement('h2');
            heading.innerHTML = strongElement.innerHTML;
            strongElement.parentNode.replaceChild(heading, strongElement);

            const nextSibling = heading.nextSibling;
            if (nextSibling && nextSibling.nodeName === 'BR') {
                nextSibling.parentNode.removeChild(nextSibling);
            }
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
            initFeaturedCollectionCarouselA11y(document);
            initProductThumbnailA11y(document);
            initRebuySearchA11y();
            initCookieBannerPositioning();
            initRebuyCartItemA11y();
            initRebuyCartVisibilityA11y();
            initRebuyCartRemoveFocus();
            initHeaderMobileDialogA11y();
            replaceContactPageStrongWithH2(document);
            replaceShopifyPolicySpanBWithH3(document);
        });
    } else {
        initFeaturedCollectionCarouselA11y(document);
        initProductThumbnailA11y(document);
        initRebuySearchA11y();
        initCookieBannerPositioning();
        initRebuyCartItemA11y();
        initRebuyCartVisibilityA11y();
        initRebuyCartRemoveFocus();
        initHeaderMobileDialogA11y();
        replaceContactPageStrongWithH2(document);
        replaceShopifyPolicySpanBWithH3(document);
    }

    document.addEventListener('shopify:section:load', function(event) {
        initFeaturedCollectionCarouselA11y(event.target);
        initProductThumbnailA11y(event.target);
        initHeaderMobileDialogA11y();
    });
})();
